<template>
  <div
    ref="waterfall"
    class="water-fall wf-wrap">
    <ul>
      <transition-group
        name="list"
        tag="li">
        <li
          v-for="(item) in waterfallList"
          :key="item.grp_id"
          :style="{
            top: item.top + 'px',
            left: item.left + 'px',
            width: item.width + 'px',
            height: item.height + 'px',
          }"
          class="wf-item">
          <img
            :src="item.src"
            @click.stop="clickImage">
          <!-- <div
            :title="item.title"
            class="image-title">
            {{ item.title || item.text_description }}
          </div> -->
          <div
            v-if="$route.path.includes('person/collection')"
            :class="{'checked' : isChecked(item)}"
            class="check-box"
            @click.stop="selectImage(item)">
            <i class="el-icon-check"/>
          </div>
        </li>
      </transition-group>
    </ul>
    <flex
      v-if="!waterfallList.length && !loading"
      align="center"
      justify="center"
      class="no_data"
    >
      暂无数据...
    </flex>
  </div>
</template>

<script>
import * as api from '@/api/index'

export default {
  name: 'Waterfall',
  props: {
    searchMethod: {
      type: String,
      default: ''
    },
    pageField: {
      type: Object,
      default: () => {}
    },
    optionsLoading: {
      type: Boolean,
      default: false
    },
    // 是否需要无限加载
    observeStatus: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      // 放图片的列表
      waterfallList: [],
      // 列数
      waterfallCol: 2,
      // 定宽
      colWidth: 236,
      // 间距
      marginRight: 6,
      marginBottom: 6,
      // 高度数组, 保存每一列的高度, 用于渲染图片(每一行图片都需要渲染到高度最低的那一列)
      colHeights: [],
      // 是否加载
      // loading: false,
      // 测试用数据, 用于模拟后端该返回多少数据
      apiIndex: 1,
      // 选中的数据列表
      selectList: [],
      loading: false,
      filterData: {}, // 筛选条件
      allPage: 1, // 总页数
      currentPage: 1, // 页码
      pageSize: 20, // 每页条数
      nextPageNo: 1, // 以图搜图下一页页码
      hasMore: false, // 以图搜图是否还有更多
      picPath: '',
      imageSearchForm: null
    }
  },
  computed: {
    isChecked () {
      return item => {
        return this.selectList.some(select => select.picId === item.picId)
      }
    }
  },
  mounted () {
    this.$root.eventHub.$on('search-by-image', (formData) => {
      this.imageSearchForm = formData
    })
  },
  destroyed () {
    this.$root.eventHub.$off('search-by-image')
  },
  methods: {
    init (filterData = {}) {
      this.filterData = filterData
      // 初始化时，每栏高度都为0
      // 创建几列
      this.waterfallList = []
      this.colHeights = new Array(this.waterfallCol)
      for (let i = 0; i < this.colHeights.length; i++) {
        // 初始化高度数组为0
        this.colHeights[i] = 0
      }
      // 计算列宽, 计算方法: (容器宽度 - 几个边距) / 列数
      this.colWidth =
        (this.$refs.waterfall.clientWidth -
          (this.waterfallCol - 1) * this.marginRight) /
        this.waterfallCol

      // 去执行方法了
      this.loadImgs(true, this.filterData)
    },

    // 加载图片对象, 只是图片对象, 还不是dom
    loadImgs (filter) {
      if (filter) {
        this.currentPage = 1
        this.waterfallList = []
      }
      let params
      if (this.$route.path.includes('search')) {
        params = {
          ...this.filterData,
          endpoint: 'GTY_STORE'
        }
      } else {
        console.log(this.filterData)
        params = {
          ...this.filterData
        }
      }
      params[this.pageField.page] = this.currentPage
      params[this.pageField.pageSize] = this.pageSize
      this.loading = true
      this.$emit('update:optionsLoading', true)
      api[this.searchMethod](params).then(res => {
        const data = res.data || res.result
        this.$emit('set-total', data.total)
        this.allPage = parseInt(data.total / this.pageSize)
        this.handleImages(data)
      }).finally(_ => {
        this.loading = false
      })
    },

    // 处理获取到的图片数据
    handleImages (data) {
      debugger
      // 返回的图片数组
      let images = data.list || data.imgList || []
      images.forEach(item => {
        if (this.$route.path.includes('search')) {
          item.coverImg = this.$options.filters.formatImgUrl(item.coverImg || item.pic_url)
        } else {
          item.coverImg = item.coverImg || item.pics_url
        }
      })
      if (this.currentPage === 1) {
        this.$emit('set-cover', images)
      }
      // // n个promise
      let promiseAll = []
      // // 存放图片对象的数组
      let imgs = []
      // // 图片总数, 用于下面遍历
      let total = images.length
      // // 请求图片数量
      // this.apiIndex = images.length + 1
      this.loading = true
      for (let i = 0; i < total; i++) {
        promiseAll[i] = new Promise((resolve, reject) => {
          // 图片对象
          imgs[i] = new Image()
          imgs[i].src = images[i].coverImg
          // 图片加载完成, 此时图片的宽高已经有值了
          imgs[i].onload = () => {
            // 存放图片数据
            let imgData = {
              ...images[i]
            }
            // 高度按照宽度变化的比例进行计算, 不计算的话, 获取不到正确的高度, 只能获取到原始的高度
            // 虽然高度是随着宽度正常变化的, 但是我们拿不到变化后的值, 因为没法监听随着宽度自动计算完后的值
            // 因此这里按照比例来计算高度 old高 / old宽 === new高 / new宽  ===>> new高 = (old高 * new宽) / old宽
            imgData.height = (imgs[i].height * this.colWidth) / imgs[i].width
            imgData.width = this.colWidth
            imgData.src = images[i].coverImg
            // 随后集成宽, 高, src等信息的对象放在待渲染的列表中
            this.waterfallList.push(imgData)
            console.log('this.waterfallList', this.waterfallList)
            // 调用该方法, 计算偏移量, 同样封装到这个对象中
            this.rankImgs(imgData)
            // 返回成功回调
            resolve(imgs[i])
          }
          imgs[i].onerror = (err) => {
            resolve(err)
            // reject(err)
          }
        })
      }
      this.$emit('update:optionsLoading', true)
      // 执行所有promise, 在这里执行观察者, 以实现懒加载(也可稍作修改实现预加载)
      Promise.all(promiseAll).then(() => {
      // 需要在这里执行观察者, 不然的话获取不到随时动态更新的dom元素, 即使使用nextTick也是
      // 因为促使dom元素更新的方法也是异步的(Promise)
      // 观察者方法在下面
        if (!this.$route.path.includes('search-by-image')) {
          if ((this.currentPage < this.allPage || this.currentPage === this.allPage) && this.observeStatus) {
            this.observe()
          }
        } else {
          if (this.hasMore) {
            this.observe()
          }
        }
      }).finally(_ => {
        this.loading = false
        this.$emit('update:optionsLoading', false)
      })
    },

    // 图片偏移的计算, 这些偏移量都保存在了imgData这个对象中, 页面会直接找到这个对象中的数据进行渲染
    // 尽量不要在vue的js代码中操作style以及获取元素的属性(尤其是随时更新的元素)
    // 会有各种意想不到的结果, vue挂载不是一次性挂载完成的, 在nextTick中执行代码, 虽然说dom已经挂载, 但是很多时候获取元素的属性还是会出问题
    // 这里将宽, 高, 以及利用宽高等计算的偏移量全都保存为变量, 封装在data的属性中, dom渲染直接拿数据就行
    // 切记避开利用dom的属性来计算值, 随后再渲染到dom上(传统js写法)
    rankImgs (imgData) {
      // 得到最小高度以及对应的索引
      let min = this.filterMin()
      // 偏移量计算
      imgData.top = min.minHeight
      imgData.left = min.minIndex * (this.colWidth + this.marginRight)
      // 更新高度数组, 图片渲染上去后高度数组需要更新
      this.colHeights[min.minIndex] += imgData.height + this.marginBottom
    },

    // 返回最小高度
    filterMin () {
      // 返回数组中的最小值, 这里的apply用法可以看我上一篇笔记
      let minHeight = Math.min.apply(null, this.colHeights)
      // 返回一个对象, 包含最小高度, 最小高度对应的索引
      return {
        minHeight: minHeight,
        minIndex: this.colHeights.indexOf(minHeight)
      }
    },

    observe () {
      let imgs = document.getElementsByClassName('wf-item')
      // 观察最后一行的第一个被渲染的元素, 不管它所在的高度如何, 它在最后一行第一个被渲染
      // 那么它渲染之前所在的列是最低高度, 那么它就会是最后一行第一个出现在可视区的
      // 那么就可以观察它的出现, 这是就可以进行请求了
      // 上面的情况是刚好渲染够每一列, 如果最后一行没有渲染满, 就不能这样计算了
      // 那么就将多的那一列去掉, 再计算
      let index
      if (this.waterfallList.length > this.waterfallCol) {
        index = this.waterfallList.length - this.waterfallCol + 1
      } else {
        index = 0
      }
      // let index = this.waterfallList.length - (this.waterfallList.length % this.waterfallCol) - this.waterfallCol + 1
      // 创建一个观察者对象, 这个对象会在观察物出现和离开可视区执行构造函数中的回调函数
      // 回调函数中两个参数, 一个是被观察对象触发时的各种数据, 一个是观察者实例对象
      const obser = new IntersectionObserver((config, observe) => {
        // 这里面是触发后的回调函数
        // config[0].intersectionRatio属性记录了元素的在可视区的比例
        // 最开始会执行一次, 因为比例是0, 当出现在可视区后, 它的比例 > 0, 具体要看一次滑动出现了多少
        // 懒加载这样的思路是, 被观察的元素(第一次加载渲染到页面上的最后一行的最高位置的元素出现在可视区, 说明下面一行没了, 且即将出现空白)
        // 就可以进行请求了, 同时移除这个观察者, 观察新的一批
        if (config[0].intersectionRatio > 0) {
          // unobserve()停止观察某个对象
          observe.unobserve(imgs[index])
          // disconnect停止观察, 观察者失效
          observe.disconnect(imgs[index])
          // 重新执行load方法, 且这个观察方法也是在那里调用的, 会增加新的观察对象
          if (!this.$route.path.includes('search-by-image')) {
            this.currentPage++
            this.loadImgs(false, this.filterData)
          }
        }
      })
      // 观察一个dom(也可以多个)
      // obser.observe(imgs[0], imgs[0])
      obser.observe(imgs[index])
    },
    clickImage () {
      this.$emit('click-img')
    },
    // 选中某个图片
    selectImage (item) {
      let index = this.selectList.findIndex(v => v.picId === item.picId)
      let image = JSON.parse(JSON.stringify(item))
      if (index > -1) {
        this.selectList.splice(index, 1)
      } else {
        this.selectList.push(image)
      }
      this.$emit('set-select', this.selectList)
    },
    // 全选
    selectAll () {
      if (this.selectList.length !== this.waterfallList.length) {
        this.selectList = JSON.parse(JSON.stringify(this.waterfallList))
      } else {
        this.selectList = []
      }
      this.$emit('set-select', this.selectList)
    },
    // 删除所选图片
    deleteImageByCollection () {
    }
  }
}
</script>

<style lang="stylus" scoped>
ul li
  list-style: none

.wf-wrap
  position relative
  width 100%
  margin 0 auto

.wf-item
  position absolute
  cursor pointer
  height 100%
  // border-radius: 8px
  overflow hidden
  border-radius 2px

  img
    width 100%
    object-fit contain
    // border-radius 8px
    // transition transform .3s ease-in-out

  /* &:hover img
    transform scale(1.2) */

  &:hover .options-wrapper
    display flex

  &:hover .image-title
    display block

  .check-box
    cursor pointer
    position absolute
    top 12px
    right 12px
    background rgba(0, 0, 0, 0.5)
    color #fff
    border-radius 2px
    width 24px
    height 24px
    text-align center
    line-height 24px
    transition all .2s
    &.checked
      background #BD2124
    &:hover
      opacity 0.8

/*定义渲染动画*/
.list-enter-active,
.list-leave-active
  transition all .5s

.list-enter, .list-leave-to
/* .list-leave-active for below version 2.1.8 */
  opacity: 0;
  // transform: translateY(30px)

.options-wrapper
  display none
  position absolute
  top 12px
  right 12px
  .options-item
    cursor pointer
    width 24px
    height 24px
    transition all .2s
    border-radius 4px
    color #fff
    background rgba(0, 0, 0, 0.5)
    &:hover
      background #BD2124

.image-title
  position absolute
  display none
  bottom 0px
  left 0px
  width 100%
  font-size 14px
  color #fff
  padding 8px 10px
  box-sizing border-box
  background-color rgba(0, 0, 0, 0.5)
  text-overflow ellipsis
  overflow hidden
  white-space nowrap
.no_data
  height 520px
</style>
